<template>
  <CustomTable :columns="columnsToMedicalRecord" :openModal="handleOpen" type="MedicalRecord" />
  <PrescriptionDetails ref="prescriptionDetails" />
</template>

<script setup>
import { columnsToMedicalRecord } from '@/components/PatientFile/ModalBody/todo/config'
import CustomTable from '@/components/PatientFile/ModalBody/todo/components/CustomTable.vue'
import PrescriptionDetails from '@/components/PreMedicalRecordModal/PrescriptionDetails.vue'
import { ref } from 'vue'

const prescriptionDetails = ref(null)

const handleOpen = data => {
  prescriptionDetails.value?.initModal(data.record.advanceMedicalRecordId)
}
</script>

<style lang="scss" scoped></style>
